const languageObj = {
  "HitPaw Online Audio Extractor": "مستخرج الصوت عبر الإنترنت HitPaw",
  "Extract sound from videos with ease.": "استخرج الصوت من مقاطع الفيديو بسهولة.",
  "Select Audio Format": "حدد تنسيق الصوت",
  "Extract Audio": "استخراج الصوت",
  "Extracting Audio": "استخراج الصوت",
  "Extracted Successfully": "تم الاستخراج بنجاح",
  "Extract New": "استخراج جديد",
  "Extraction Failed": "فشل الاستخراج",
  "Format": "صيغة",
};

export default languageObj